export default __webpack_public_path__ + "static/media/09.b6554d82.jpg";